import TemplatePreviewPane from './TemplatePreviewPane';

export default TemplatePreviewPane;
